export const ResultItemQuestions = {
  productRangeKey: 'affordabilityCalculator.results.',
  termAndTypeKey: 'affordabilityCalculator.results.termAndType',
  typeValueKey: 'affordabilityCalculator.results.type.',
  ltvPercentKey: 'affordabilityCalculator.results.ltvPercent',
  feeKey: 'affordabilityCalculator.results.fee',
  repaymentsKey: 'affordabilityCalculator.results.repayments',
  initialRateKey: 'affordabilityCalculator.results.initialRate',
  maxFinancingKey: 'affordabilityCalculator.results.maxFinancing',
  reversionRateKey: 'affordabilityCalculator.results.reversionRate',
};
